import { createUseDistributorsData } from '@akyga/shared-ui/useDistributorsData';
import httpClient from 'API/httpClient';

export default createUseDistributorsData(httpClient);
